module.exports = __webpack_public_path__ + "static/img/sm_bot2.02155a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/sm_bot2.png
// module id = jDJG
// module chunks = 1